<div class="d-flex flex-row align-items-center">
  @for(item of data; track item?.name; let i = $index) {
  <div
    class="breadcrumb-node mx-1"
    [class.breadcrumb-root]="item.isRootNode && isAgentic"
    [ngClass]="{ clickable: item.clickable || item.isDropdown }"
  >
  <mat-icon *ngIf="item.icon" >{{item.icon}}</mat-icon>
  <img *ngIf="item.imgPath" [src]="item.imgPath" alt="Icon" />

  <!-- Plain node -->
  <span *ngIf="!item.isDropdown" (click)="nodeClick(item)" (keydown)="nodeClick(item)" class="breadcrumb-item-name"> {{ item.name }}</span>

  <!-- Dropdown node -->
  <span *ngIf="item.isDropdown" class="breadcrumb-dropdown-trigger" [matMenuTriggerFor]="cycleMenu">
    <span class="breadcrumb-item-name">{{ item.name }}</span>
    <mat-icon class="breadcrumb-dropdown-icon">arrow_drop_down</mat-icon>
  </span>
  <mat-menu #cycleMenu="matMenu" class="breadcrumb-cycle-menu">
    @for(option of item.dropdownItems; track option.value) {
      <button mat-menu-item
        [class.active-cycle]="option.value === item.selectedDropdownValue"
        (click)="onDropdownSelect(item, option)">
        {{ option.label }}
      </button>
    }
  </mat-menu>

  </div>
  @if(i !== this.data.length- 1) {
  <div class="breadcrumb-separator mx-2">{{ separator }}</div>
  } }
</div>
